import React from 'react';
import { overridable } from '@24i/nxg-sdk-gluons/src/context/ComponentOverrides';
import AppGrid from '../../AppGrid';

const GridWithLazyLoading = (props) => <AppGrid {...props} />;

export default overridable(GridWithLazyLoading, 'GridWithLazyLoading');
